import createReducer from '../utils/createReducer';
import {
  FINANCE_SOURCES_REQUEST,
  FINANCE_SOURCES_FAILURE,
  FINANCE_SOURCES_SUCCESS,

} from '../constants/actions';

const initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null,
};

export default createReducer(initialState, {
  [FINANCE_SOURCES_REQUEST]: state => (
    Object.assign({}, state, {
      isError: false,
    })
  ),
  [FINANCE_SOURCES_SUCCESS]: (state, payload) => (
    Object.assign({}, state, {
      data: [].concat(payload.data),
      token: payload.token,
    })
  ),
  [FINANCE_SOURCES_FAILURE]: (state, payload) => (
    Object.assign({}, state, {
      isError: true,
      statusText: payload.message,
    })
  ),
});



// WEBPACK FOOTER //
// ./src/reducers/financeSources.js